













































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { ProfileState } from '../store/types';
const namespace = 'profile';

@Component({
    name: 'LoginUser',
    components: {},
})
export default class LoginUser extends Vue {
    @State('profile') private profile!: ProfileState;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchData', { namespace }) private fetchData: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('login', { namespace }) private login: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Mutation('storeToken', { namespace }) private storeToken: any;
    @Getter('fullName', { namespace }) private fullName!: string;

    private showPassword = false;
    private email = '';
    private password = '';
    private grantType = 'password';
    private clientId = '099153c2625149bc8ecb3e85e03f0022';
    private errors: string[] = [];

    private userLogin() {
        this.login(
            `username=${this.email}&password=${this.password}&grant_type=${this.grantType}&client_id=${this.clientId}`,
        )
            .then(() => {
                this.$router.push({ name: 'home' });
            })
            .catch((err: unknown) => {
                console.error(err);
            });
    }
}
